import TeamspaceImg from '@/shared/assets/images/teamspaces-upgrade-banner.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { BoosterType } from '@/shared/types/Billing';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Teamspaces',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  checkIsSpaceOwner: false,
  features: getBullets([
    'teamspaceCreatorPro',
    'translate100',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
    'simultaneousMultiLanguageTranslation',
  ]),
  media: {
    src: TeamspaceImg,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.teamSpaceUpgradeClick,
  mixpanelOpeningEvent: MixpanelEvents.upgradeTeamspaceModalShown,
  subtitle: 'Upgrade to Creator Pro to have Teamspace with up to 3 members',
};

const CREATOR_PLAN_CONTENT = {
  ...BASE_CONTENT,
  title: 'Unlock Teamspaces',
  booster: BoosterType.TeamspaceSeat,
  buttonText: 'or Upgrade to Creator Pro',
  content: {
    chip: {
      title: 'Teams cut project coordination time by 60%',
    },
    learnMore: {
      title: 'Learn more',
      link: 'https://help.rask.ai/hc/introducing-teamspaces',
      text: 'about Teamspace collaboration',
    },
    perfectFor: {
      title: 'Perfect for',
      text: 'agencies and teams managing multiple dubbing projects without the chaos.',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: 'Work better together',
      bullets: [
        'Invite teammates with individual logins - no shared credentials',
        'Give full feature access for invitees without extra subscriptions',
        'Work on shared projects seamlessly - no back and forth file transfers',
      ],
    },
  },
  features: [],
  subtitle: 'Collaborate with your team in one place.',
};

const CREATOR_PRO_PLAN_CONTENT = {
  ...CREATOR_PLAN_CONTENT,
  title: 'Scale your team',
  buttonText: 'or Upgrade to Business',
  content: {
    ...CREATOR_PLAN_CONTENT.content,
    selectedPlan: 'Business',
  },
  subtitle: 'Upgrade to Business for a Teamspace with 5 seats, or add the seats you need.',
};

const BUSINESS_PLAN_CONTENT = {
  ...CREATOR_PRO_PLAN_CONTENT,
  buttonText: 'or Contact us',
  subtitle: 'Upgrade to Enterprise for custom Teamspaces and member limits, or add the seats you need.',
};

const SCALE_TEAM: ModalContent = {
  title: 'Looking to scale your team?',
  bulletsHeader: '',
  buttonText: BUTTON_TEXTS.contactUs,
  features: [],
  media: {
    src: TeamspaceImg,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.upgradeTeamspaceModalClickContactUs,
  mixpanelOpeningEvent: MixpanelEvents.upgradeTeamspaceModalShown,
  subtitle: 'Contact us to find the right number of Teamspaces and members for your team.',
};

export const TEAMSPACE_CONTENT: LimitedFeatureContent = {
  business: BUSINESS_PLAN_CONTENT,
  creator: CREATOR_PLAN_CONTENT,
  creatorPro: CREATOR_PRO_PLAN_CONTENT,
  custom: SCALE_TEAM,
  enterprise: BUSINESS_PLAN_CONTENT,
  starter: BASE_CONTENT,
  trial: BASE_CONTENT,
};
